import { ICardWithBulletsData } from "../interfaces/card-info.interface";

export const NUMBER_ICON_DIR = 'images/shared/steps';

export const AEO_BULLETS: ICardWithBulletsData[] = [
    {
        icon: `${NUMBER_ICON_DIR}/01.png`,
        title: 'entity optimization',
        subtitle: `We structure your brand so AI systems clearly understand:`,
        bullets: [
            'Who you are',
            'What you do',
            `Why you're relevant`
        ],
        outro: 'This includes semantic consistency across your entire digital footprint.'
    },
    {
        icon: `${NUMBER_ICON_DIR}/02.png`,
        title: 'ai-readable content architecture',
        subtitle: `We build and restructure content so it can be:`,
        bullets: [
            'Parsed by AI models',
            'Extracted into answers',
            'Selected for summaries and recommendations'
        ],
        outro: `This is not blog spam. It's precision-engineered answer content.`
    },
    {
        icon: `${NUMBER_ICON_DIR}/03.png`,
        title: 'authority signal development',
        subtitle: `AI doesn't guess—it selects based on confidence. We strengthen:`,
        bullets: [
            'Topical authority',
            'Brand mentions',
            'Contextual relevance',
            'Trust signals across the web'
        ],
    },
    {
        icon: `${NUMBER_ICON_DIR}/04.png`,
        title: 'answer targeting strategy',
        subtitle: `We identify the exact questions your buyers are asking:`,
        bullets: [
            `"Best [service] near me"`,
            `"Who should I hire for [problem]"`,
            `"Top companies for [solution]"`
        ],
        outro: 'Then we position your business as the <b>default answer</b>.'
    },
    {
        icon: `${NUMBER_ICON_DIR}/05.png`,
        title: 'multi-platform ai visibility',
        subtitle: `We optimize your presence across:`,
        bullets: [
            'Google AI Overviews',
            'ChatGPT responses',
            'Consistent branding',
            'Featured snippets',
            'Knowledge panels'
        ]
    },
];